import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const categoryDeleteAtom = createMutationAtomFactory(
  'settings.categoryDelete',
  (params: { id: string }) => ({
    inventoryCategoryDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
